// extracted by mini-css-extract-plugin
export var loading = "styles-module--loading--jMDYM";
export var shimmer = "styles-module--shimmer--+dll3";